export default __webpack_public_path__ + "static/SRF Carasweet 5SG7804 - Product Specifications & Technical Data-bc6dcede19c1084e9e218a3e1965bebc.pdf";